import { useState, useEffect } from 'react';
import { API_URL } from "../../shared/constant";
import { Oval } from "react-loader-spinner";
import { toast } from "react-toastify";
import AsyncSelect from 'react-select/async';
import axios from 'axios';
import Swal from "sweetalert2";

const ProductPermission = () => {
    const [selectedOption, setSelectedOption] = useState(null);
    const [loading, setLoading] = useState(true);
    const [userData, setUserData] = useState([]);
    const [whoCanSee, setWhoCanSee] = useState('0');
    const [formData, setFormData] = useState({ user_id: "" });

    const fetchOptions = async (inputValue) => {
        if (inputValue && inputValue.length > 2) {
            try {
                const res = await axios.post(API_URL.USERS_SEARCH, { text: inputValue });
                return res.data.map((user) => ({
                    label: user.name,
                    value: user.id,
                }));
            } catch (error) {
                return [];
            }
        }
        return [];
    };

    const getUsers = () => {
        setLoading(true);
        axios.post(API_URL.USERS_WHO_CAN_SEE, {}).then(
            (res) => {
                if (res.data.status === 1) {
                    setUserData(res.data.data);
                }
                setLoading(false);
            },
            () => {
                setLoading(false);
                toast.error("Something went wrong..", { autoClose: 3000 });
            }
        );
    };

    const updateWhoCanSee = (value) => {
        setWhoCanSee(value);
        axios.post(API_URL.USERS_UPDATE_WHO_CAN_SEE, { who_can_see: value }).then(
            (res) => {
                if (res.data.status === 1) {
                    toast.success("Setting updated", { autoClose: 2000, position: "top-right" });
                }
            }
        );
    };

    const addUser = () => {
        if (!formData.user_id) return;
        setLoading(true);
        axios.post(API_URL.USERS_ADD_WHO_CAN_SEE, { user_id: formData.user_id })
            .then((res) => {
                if (res.data.status === 1) {
                    toast.success("Permission added", { autoClose: 3000, position: "top-right" });
                    setSelectedOption(null);
                    setFormData({ user_id: "" });
                    getUsers();
                } else {
                    toast.error(res.data.data?.msg || "Customer already added.", { autoClose: 3000 });
                    setLoading(false);
                }
            })
            .catch(() => setLoading(false));
    };

    const deleteUser = (row) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You want to remove permission",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, remove it!",
        }).then((result) => {
            if (result.isConfirmed) {
                setLoading(true);
                axios.post(API_URL.USERS_REMOVE_WHO_CAN_SEE, { user_id: row.id }).then(
                    (res) => {
                        if (res.data.status === 1) {
                            setUserData(userData.filter((r) => r.id !== row.id));
                            toast.success("Permission removed successfully", { autoClose: 3000 });
                        }
                        setLoading(false);
                    },
                    () => {
                        setLoading(false);
                        toast.error("Something went wrong..", { autoClose: 3000 });
                    }
                );
            }
        });
    };

    useEffect(() => {
        getUsers();
    }, []);

    return (
        <div className="row">
            <div className="col-6">
                <h1>Product Permission</h1>
            </div>
            <div className="col-md-12">
                <div className="card">
                    <div className="card-header">Product Settings</div>
                    <div className="card-body">
                        <div className="row align-items-end">
                            <div className="col-md-4">
                                <div className="form-group">
                                    <select
                                        className="form-control"
                                        value={whoCanSee}
                                        onChange={(e) => updateWhoCanSee(e.target.value)}
                                    >
                                        <option value="0">ALL</option>
                                        <option value="1">Selected Customers Only</option>
                                    </select>
                                </div>
                            </div>
                            {whoCanSee === '1' && (
                                <>
                                    <div className="col-md-5">
                                        <div className="form-group">
                                            <label>Select Customers</label>
                                            <AsyncSelect
                                                cacheOptions
                                                loadOptions={fetchOptions}
                                                defaultOptions
                                                onChange={(option) => {
                                                    setSelectedOption(option);
                                                    setFormData({ user_id: option ? option.value : "" });
                                                }}
                                                value={selectedOption}
                                                placeholder="Search User"
                                                isClearable
                                                styles={{
                                                    control: (base) => ({
                                                        ...base,
                                                        borderColor: '#ccc',
                                                        boxShadow: 'none',
                                                        '&:hover': { borderColor: '#aaa' },
                                                    }),
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <button onClick={addUser} className="btn btn-primary mb-3">
                                            <i className="fa fa-plus me-1"></i> Add
                                        </button>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            {whoCanSee === '1' && (<div className="col-sm-12 pt-3">
                <div className="card">
                    <div className="card-body p-0">
                        {loading ? (
                            <Oval
                                height={60}
                                width={60}
                                color="#7539ff"
                                wrapperStyle={{ justifyContent: "center" }}
                                visible={true}
                                ariaLabel="oval-loading"
                                secondaryColor="#7539ff"
                                strokeWidth={2}
                                strokeWidthSecondary={2}
                            />
                        ) : (
                            <div className="table-responsive">
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th>Name</th>
                                            <th>Address</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {userData.map((row, key) => (
                                            <tr key={key}>
                                                <td>{row.name}</td>
                                                <td>{row.address}</td>
                                                <td>
                                                    <button
                                                        onClick={() => deleteUser(row)}
                                                        className="btn btn-sm btn-danger"
                                                    >
                                                        <i className="fa fa-trash me-1"></i> Delete
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </div>
                </div>
            </div> )}
        </div>
    );
};

export default ProductPermission;
